import React from 'react';

import { Svg, type SvgProps } from './svg';

export function ChevronFilledIcon(props: SvgProps) {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" data-testid="chevron-filled-icon" {...props}>
      <path d="M4.66669 6.66675L8.00002 10.0001L11.3334 6.66675H4.66669Z" />
    </Svg>
  );
}
